import { useContext } from 'react';
import { createPortal } from 'react-dom';
import { ModalContext } from '../Layout/Layout';

export const Modal = ({ children }) => {
  const root = useContext(ModalContext);

  return root.current && createPortal(children, root.current);
};
